
export default function routes($stateProvider) {

	var resolve = {
		loggedIn: ['User', function (User) {
			return User.requireLogin();
		}],
		marketer: ['Marketer', '$stateParams', function (Marketer, $stateParams) {
			return Marketer.get($stateParams.id);
		}],
		zones: ['Zone', function (Zone) {
			return Zone.all()
		}],
		empty: [function () {
			return Promise.resolve();
		}]
	};

	var conf = {
		template: require('./marketerForm.html'),
		controller: 'MarketerFormController',
		controllerAs: 'marketerForm'
	};

	$stateProvider
		.state('marketerEditPage', angular.extend({
			url:     '/marketer/:id',
			resolve: {
				loggedIn:      resolve.loggedIn,
				marketer:      resolve.marketer,
				zones:         resolve.empty,
			}
		}, conf))
		.state('marketerCreatePage', angular.extend({
			url:     '/marketer-create',
			resolve: {
				loggedIn:      resolve.loggedIn,
				marketer:      resolve.empty,
				zones:         resolve.zones,
			}
		}, conf));
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/marketerForm/marketerForm.routes.js